import React from "react";
import styles from "./WaysToStyleModalCarousel.scss";
import StylingLookHeroImage from "./StylingLookHeroImage";
import { useWaysToStyle } from "../../context/waysToStyle/WaysToStyleContext";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import useCarouselAnimationScroll from "./useCarouselAnimationScroll";
import LookLabel from "./LookLabel";
import { StylingLookWithStockPrice } from "../../types/productTypes/stylingLookProduct";
import classnamesBind from "classnames/bind";

const classnames = classnamesBind.bind(styles);

interface WaysToStyleModalCarouselProps {
  selectedStylingLook: StylingLookWithStockPrice;
  onSelectedLookIndexChange: (index: number) => void;
  isOpen: boolean;
  contentLoaded: boolean;
}

const WaysToStyleModalCarousel: React.FC<WaysToStyleModalCarouselProps> = ({
  selectedStylingLook,
  onSelectedLookIndexChange,
  isOpen,
  contentLoaded,
}) => {
  const { stylingLooksWithStockPrice } = useWaysToStyle();
  let selectedLookIndex = stylingLooksWithStockPrice.findIndex(
    (look) => look.id === selectedStylingLook?.id,
  );
  if (selectedLookIndex === -1) selectedLookIndex = 0;

  const { containerRef } = useCarouselAnimationScroll(
    selectedLookIndex,
    isOpen,
    onSelectedLookIndexChange,
    contentLoaded,
  );

  const { getTranslation } = useRuntimeConstants() as {
    getTranslation: (key: string) => string;
  };

  const isSingleLook = stylingLooksWithStockPrice.length === 1;

  return (
    <section
      className={styles.container}
      ref={containerRef}
      data-testid="modalCarouselContainer"
      aria-label={getTranslation("pdp_ways_to_style_title")}
      aria-roledescription="carousel"
    >
      {stylingLooksWithStockPrice.map((look) => (
        <div
          className={classnames(styles.lookCarouselItem, {
            singleItem: isSingleLook,
          })}
          key={look.id}
        >
          <StylingLookHeroImage
            look={look}
            additionalClasses={styles.heroImage}
          />
          {contentLoaded && (
            <LookLabel look={look} additionalClasses={styles.modalLookLabel} />
          )}
        </div>
      ))}
    </section>
  );
};

export default WaysToStyleModalCarousel;
